<template>
  <div :class='$style.verification_confirm'>
    <div v-if="!processing">
      <h1 :class='$style.title'>認証コード入力</h1>
      <p :class='$style.note'>くみあいアプリより通知された認証コードを<br>60分以内に入力してください</p>

      <div :class="$style.input_group">
        <base-input name="code" type="password" look="border" v-model="code" maxlength="6"
          :error="error_text"
        >
          <template v-slot:prepend>
            <span :class='$style.input_prepend_code'>認証コード</span>
          </template>
        </base-input>
      </div>

      <div :class="$style.resend_link_wrap">
        <a :class="$style.resend_link" href="#" v-on:click="resendCode">
          認証コードが届かない<br />再送する
        </a>
      </div>

      <p :class="$style.resend" v-show="isResend">
        認証コードを再送しました。<br />再度メッセージを確認してください。
      </p>

      <div :class="$style.next_button_wrap">
        <base-button display="inline-block" width="100%" height="50px" @click="sendCode"
          :disabled="processing">
          送信
        </base-button>
      </div>
    </div>

    <div :class="$style.spinner" v-if="processing">
      <base-icon name="spinner" size="32px" spin />
    </div>

  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput/BaseInput'
import BaseButton from '@/components/base/BaseButton/BaseButton'
import BaseIcon from '@/components/base/BaseIcon/BaseIcon'

export default {
  name: 'Tfa',
  components: { BaseInput, BaseButton, BaseIcon },
  data() {
    return {
      code: '',
      uuid: '',
      isResend: false,
      error_text: '',
      processing: false,
    }
  },
  created: async function () {
    // URLからUUIDを取得
    const urlParams = new URLSearchParams(window.location.search)
    this.uuid = urlParams.get('uuid')
  },
  methods: {
    async sendCode() {

      if (this.processing) {
        return
      }

      this.processing = true
      this.error_text = ''

      // 二要素認証登録APIコール
      this.$axios
        .post('/api/' + this.$constants.API_VERSION + '/login/tfa', {
          uuid: this.uuid,
          code: this.code,
        })
        .then((response) => {
          this.$store.commit('auth/setTelOrEmail', response.data.value.cognition_id)
          this.$store.commit('auth/setJuid', response.data.value.juid)

          this.$cookies.set('auth_info', {
            'tel_or_email': response.data.value.cognition_id,
            'access_token': response.data.value.access_token,
            'expired_at': this.$dayjs().add(response.data.value.expires_in, 's').format(),
            'refresh_token': response.data.value.refresh_token
          })

          //ページ遷移
          const route = this.$route.query.redirect
          if (route) {
            this.$router.push(route)
          } else {
            this.$router.push('/home/home')
          }
        }).catch(err => {
          if(err.response.status === 400 || err.response.status === 401){
            err.response.data.value.errors.forEach(error => {
              this.error_text = error.message
              this.isResend = false
            })
          }
          this.processing = false
        })
    },
    resendCode() {
      this.error_text = ''

      // 二要素認証コード再送APIコール
      this.$axios
        .post('/api/' + this.$constants.API_VERSION + '/login/tfa/resend', {
          uuid: this.uuid,
        })
        .then(() => {
          this.isResend = true
        }).catch(err => {
          if(err.response.status === 400 || err.response.status === 401){
            err.response.data.value.errors.forEach(error => {
              this.error_text = error.message
              this.isResend = false
            })
          }
        });
    },
  },
}
</script>
<style lang='scss' module>
.verification_confirm {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 42px 32px 30px 32px;
  box-sizing: border-box;
  text-align: left;
}

.title {
  margin-top: 0;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 50px;
}

.note,.resend {
  font-size: 13px;
  text-align: left;
  color: $fontBlack;
  margin-top: 0;
  margin-bottom: 38px;
}

.input_group {
  margin-bottom: 30px;
}

.input_prepend_code {
  font-size: 11px;
  color: $fontBlack !important;
  margin-right: 0px;
  cursor: default;
}

.next_button_wrap {
  margin-top: auto;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
}

.resend_link_wrap {
  text-align: center;
  margin-bottom: 38px;
}
.resend_link {
  color: $KeyDarkGreen;
  font-size: 13px;
}
</style>